<template>
  <div class="items-center justify-center space-x-3 lg:space-x-0 lg:space-y-3">
    <img
      src="/landing/images/apple-store.png"
      alt="App Store"
      class="object-contain"
    />
    <img
      src="/landing/images/google-play.png"
      alt="Google Play"
      class="object-contain"
    />
  </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
